export default __webpack_public_path__ + "static/media/bijnis.2a4b1d45.png";